<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div
      v-if="!initialForm && currentComponent !== 'apply-success'"
      class="card"
      style="width: 75%"
    >
      <header class="card-header">
        <p class="card-header-title">
          {{ $t('jobApplyCardTitle') }}
        </p>
      </header>
      <div class="card-content">
        <component
          :is="currentComponent"
          :job-detail="jobDetail"
          @next="currentComponent = $event"
          @close="$emit('close')"
        ></component>
      </div>
    </div>
    <div v-else-if="initialForm && currentComponent !== 'apply-success'">
      <account-base
        class="modal-content has-margin-left-50-mobile has-overflow-x-hidden"
        :type="'details'"
        :initial-form="initialForm"
        @close="$emit('close')"
        @initialFormSuccess="$emit('success')"
      ></account-base>
      <button class="modal-close is-large" @click="$emit('close')"></button>
    </div>
    <div v-else style="width: 45%" class="card">
      <apply-success @close="$emit('close')"></apply-success>
    </div>
  </div>
</template>

<script>
import FormMixin from '@/mixins/veeValidate'
import AccountBase from '@/components/Accounts/AccountBase'
export default {
  components: {
    Questions: () => import('@/components/Job/Apply/Questions'),
    Document: () => import('@/components/Job/Apply/Document'),
    ApplySuccess: () => import('@/components/Job/Apply/ApplySuccess'),
    AccountBase
  },
  mixins: [FormMixin],
  props: {
    jobDetail: {
      type: Object,
      required: true
    },
    initialForm: {
      type: Boolean,
      default: false
    },
    nextComponent: {
      type: String,
      default: 'questions'
    }
  },
  data() {
    return {
      currentComponent: this.nextComponent
    }
  }
}
</script>
<style scoped></style>
